import { memo } from 'react';
import Typography from '@mui/material/Typography';
import { useTranslation } from 'react-i18next';
import { UseFormReturn, Controller } from 'react-hook-form';

import { validationRules } from 'helpers/utils';
import TextAreaElement from 'components/muiInputWrappers/TextAreaElement';

function ShortAnswer({
  form,
  id,
  itemFull,
  isEditable = true,
  disabled = true,
  isReadOnly
}: {
  disabled?: boolean;
  id: string;
  isReadOnly?: boolean;
  form: UseFormReturn;
  isEditable?: boolean;
  itemFull?: { idSurveyQuestion: string; isRequired: boolean };
}) {
  const { t } = useTranslation('global');
  const { validateSpaces } = validationRules();

  return (
    <div style={{ width: '100%' }}>
      {isEditable ? (
        <>
          {/* Campo oculto para idSurveyQuestion */}
          <Controller
            control={form.control}
            defaultValue={itemFull?.idSurveyQuestion || ''}
            name={`${id}-idSurveyQuestion`} // Registra idSurveyQuestion en el formulario
            render={({ field }) => (
              <input
                type="hidden"
                {...field}
                value={itemFull?.idSurveyQuestion}
              />
            )}
          />

          <TextAreaElement
            disabled={isReadOnly}
            form={form}
            hasHelperText={!disabled}
            maxLength={500}
            name={`${id}-paragraph`}
            placeholder={
              isReadOnly
                ? t('survey.messages.text500')
                : t('survey.messages.enterAnswer')
            }
            required={isReadOnly ? false : itemFull?.isRequired} // Requiere si no es de solo lectura y es obligatorio
            validation={{
              required: {
                value: isReadOnly ? false : itemFull?.isRequired,
                message: t('common.commonMessages.requiredField', {
                  field: `${id}-paragraph`
                })
              },
              validate: validateSpaces,
              maxLength: {
                value: 500,
                message: t('survey.messages.valueLonger', { number: '500' })
              }
            }}
            variant={isReadOnly ? 'filled' : 'outlined'}
            fullWidth
          />
        </>
      ) : (
        <Typography variant="caption">
          {form.getValues(`${id}-paragraph`)}
        </Typography>
      )}
    </div>
  );
}

export default memo(ShortAnswer);
